import { useEffect } from "react";
import { Container, Image, Button } from 'react-bootstrap';
import {Link } from "react-router-dom";
import {
    CareersSection,
    SupportMission,
    SupportMissionContent,
    SupportMissionText,
    SupportImage,
    OurImpactTitle,
    Opening,
    OpeningTitle,
    OpeningPosition, 
    OpeningPositionDetail,
    OpeningImage,
    PositionTitle,
    PositionList,
    PositionItem,
    PositionExperience,
    PositionYear,
    ApplyNowBtn,
    OpeningSection,
    NoOpening, 
    NoOpeningImage,
    NoOpeningTitle,
} from './careersStyle';
import NoOpeningCol from '../../../assests/images/noopening.webp';
import ViewProfessional from '../../../assests/images/view-professional.webp';
import GreatNonProfits from '../../../assests/images/greatnonprofits.webp';
import { AdvocacyTitle, ElliottAdvocacyBanner } from "../../../components/common/commonSubPageBanner/commonSubPageBannerStyle";
import { careersHandler } from "../../../redux/slices/careers/careers-slice";
import { useDispatch, useSelector } from "react-redux";
import { MESSAGE } from "../../../utils/message";
import MetaComponent from "../../../components/common/metaComponent";

const Careers = () => {
    const dispatch:any = useDispatch()
    const allCareersList = useSelector((state:any) => state?.careers?.data)
    useEffect(() => {
        dispatch(careersHandler())
    },[])

    return (
        <>
        <MetaComponent 
            keywords=""
            description=""
            ogTitle="Careers & Volunteering | GreatNonprofits"
            ogDescription=""
            ogUrl="https://www.about.greatnonprofits.org/careers"
            ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
        />
            <ElliottAdvocacyBanner className="career-banner-sec">
                <Container className="cont-w">
                <AdvocacyTitle className='title-sub-page'>{MESSAGE.workWithUs}</AdvocacyTitle>
                </Container>
            </ElliottAdvocacyBanner>

            <CareersSection>
                <Container className="cont-w">
                    <SupportMission>
                        <SupportMissionContent>
                            <OurImpactTitle>{MESSAGE.careersVolunteering}</OurImpactTitle>
                            <SupportMissionText>
                               {MESSAGE.careersDetailText}
                            </SupportMissionText>
                            <SupportMissionText>
                               {MESSAGE.inquiryText}
                                 <Link to="mailto:perlani@greatnonprofits.org"><strong>  perlani@greatnonprofits.org</strong></Link>
                            </SupportMissionText>
                        </SupportMissionContent>
                        <SupportImage>
                            <Image src={ViewProfessional} />
                        </SupportImage>
                    </SupportMission>
                </Container>
            </CareersSection>
            
            <Opening>
                <Container className="cont-w">
                    <OpeningSection>
                    <OpeningTitle>{MESSAGE.opening}</OpeningTitle>

                    {allCareersList && allCareersList.data.length >0 ? 
                        allCareersList.data.map((career:any, index:number) => (
                            <OpeningPosition key={index+1}>
                                <OpeningImage>
                                    <Image src={GreatNonProfits} />
                                </OpeningImage>
                                <OpeningPositionDetail>
                                    <PositionTitle>{career.jobTitle}</PositionTitle>
                                    <PositionList>
                                        <PositionItem>
                                            <PositionExperience>{MESSAGE.experience} :</PositionExperience>
                                            <PositionYear>{career.experience}</PositionYear>
                                        </PositionItem>
                                        <PositionItem>
                                            <PositionExperience>{MESSAGE.numOpenings} :</PositionExperience>
                                            <PositionYear>{career.openings}</PositionYear>
                                        </PositionItem>
                                        <PositionItem>
                                            <PositionExperience>{MESSAGE.qualification} :</PositionExperience>
                                            <PositionYear>{career.qualification} </PositionYear>
                                        </PositionItem>
                                    </PositionList>
                                </OpeningPositionDetail>
                                <ApplyNowBtn><Button className="btn-outline-success-blue">{MESSAGE.applyNow}</Button></ApplyNowBtn>
                             </OpeningPosition>
                        ))
                    :
                        <NoOpening>
                            <NoOpeningImage><Image src={NoOpeningCol} /></NoOpeningImage>
                            <NoOpeningTitle>{MESSAGE.noJobOpening}</NoOpeningTitle>
                        </NoOpening> 
                    }
                    </OpeningSection>
                </Container>
            </Opening>
        </>
    )
};
export default Careers;